import PropTypes from 'prop-types';
import { Component } from 'react';

export default class ProductsSection extends Component {
  render() {
    return (
      <div className="products-section">
        {this.props.children}
      </div>
    )
  }
}

ProductsSection.propTypes = {
  children: PropTypes.node,
};